import React from 'react';
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import fn from '../../Functii';
import _ from 'underscore';

import { acAxiosRequest } from '../actions/acAxiosRequest'
import { acActiveLot } from '../actions/acActiveLot'
import { acRundaSelectata } from '../actions/acRundaSelectata'
import { acConSizeChange } from '../actions/acConSizeChange'
import { acLiveLot } from '../actions/acLiveLot'

class ButStItem extends React.Component {


    constructor() {
        super();
        this.state = {
            countries: [],
            loteriiTop: [],
            loteriiNormale: []
        };
    }
    componentDidMount() {
        if (this.props.loterii) {
            this.setState({
                loteriiTop: this.topLotteries(),
                loteriiNormale: this.normalLotteries()
            })
        }
        if ((this.props.activeLot === null) && (this.props.loterii !== null)) {
            this.props.acActiveLot(this.props.loterii[0]);
            this.setState({
                countries: [this.props.loterii[0].tara]
            })
        }
    }
    isActive(val, tari) {
        if (this.props.activeLot === null) {
            if (this.props.loterii[0].name_lot === val) {
                return 'active';
            }
        }
        else if (this.props.activeLot.name_lot === val) {
            return 'active';
        }
    }
    isActiveFromSelect(val) {
        if (this.props.activeLot === null) {
            if (this.props.loterii[0].name_lot === val) {
                return 'sec-selected';
            }
        } else if (this.props.activeLot.name_lot === val) {
            return 'sec-selected';
        }
    }

    changeActive(val, e) {
        var loterieInfo = this.props.loterii.filter(x => x.name_lot === val);
        this.props.acActiveLot(loterieInfo[0]);

        var axios = {
            ruta: this.props.appProps.ruta,
            reducer: 'RUNDE',
            request: 'get_rounds',
            value: 'lottery_name=' + loterieInfo[0].name_lot.replace(/ /g, "_") + '&type=0',
            loading: true,
            error: '3100',
            newParam: this.props.sessionParam
        }
        this.props.acAxiosRequest(axios);

        if (loterieInfo[0].fastvisual === true || loterieInfo[0].visual === true) {
            var live = {
                ruta: this.props.appProps.ruta,
                request: 'get_rounds',
                reducer: 'LOTTO_LIVE_ROUNDS',
                value: 'lottery_name=' + loterieInfo[0].name_lot.replace(/ /g, "_") + '&type=1&next_page=0',
                extra: 'runde',
                error: '3200',
                newParam: this.props.sessionParam
            }
            this.props.acAxiosRequest(live)
            this.props.acLiveLot(loterieInfo[0].name_lot)
        }
        e.stopPropagation();

    }
    uniq(a) {
        var seen = {};
        return a.filter(function (item) {
            return seen.hasOwnProperty(item) ? false : (seen[item] = true);
        });
    }
    topLotteries() {
        var findTopLotteries = _.where(this.props.loterii, { top: true })
        return findTopLotteries
    }
    normalLotteries() {
        var normalLotMinusTop = _.where(this.props.loterii, { top: false })
        return normalLotMinusTop
    }
    liveLot(val) {
        let index = 0;
        if ((val.visual === true || val.fastvisual === true) && val.higherodds === true) {
            return [
                <img key={index} className="live-lot" src="img/icon/live.png" alt="" />,
                <div key={++index} className="coteMarite"><span>{this.props.multiLang.coteMarite.txt}</span></div>
            ]
        } else {
            if (val.higherodds === true) {
                return [<div key={index} className="coteMarite"><span>{this.props.multiLang.coteMarite.txt}</span></div>]
            } else if (val.visual === true || val.fastvisual === true) {
                return [<img key={index} className="live-lot" src="img/icon/live.png" alt="" />]
            }
        }
    }
    liveCountries(val) {
        var whereCuntryes = _.where(this.props.loterii, { tara: val })

        var findCountry = whereCuntryes.filter((val, i) => val.fastvisual === true || val.visual === true)
        if (findCountry.length > 0) {
            return <img className="live-country" src="img/icon/live.png" alt="" />
        }
    }
    liList() {
        if (this.props.appProps.colStLotteries === 'list') {
            return (
                <ul>
                    {this.props.loterii.map((val) => {
                        return <li
                            key={val.name_lot}
                            className={this.isActive(val.name_lot)}
                            onClick={this.changeActive.bind(this, val.name_lot)}>
                            <div>
                                <div className="img-con"><img src={"img/steaguri/" + this.props.appProps.steaguri + '/' + val.country_flags.toLowerCase().replace(/ /g, "_") + ".png"} alt="" /></div>
                                <div className="lot-name">{val.name_lot + ' ' + val.game_type}</div>
                            </div>
                        </li>
                    })}
                </ul>
            )
        }
        if ((this.props.appProps.colStLotteries === 'dropDown') && (this.props.conSizeChange.appW && this.props.conSizeChange.appW >= 1000)) {
            var tari = [];
            for (var i = 0; i < this.state.loteriiNormale.length; i++) {
                tari.push(this.state.loteriiNormale[i].tara)
            }
            if (this.props.topLoterii) {
                var topLotteries = this.topLotteries();
                return (
                    <ul>
                        {topLotteries.map((val) => {
                            return <li
                                key={val.name_lot}
                                className={this.isActive(val.name_lot)}
                                onClick={this.changeActive.bind(this, val.name_lot)}>
                                <div>
                                    <div className="img-con"><img src={"img/steaguri/" + this.props.appProps.steaguri + '/' + val.country_flags.toLowerCase().replace(/ /g, "_") + ".png"} alt="" /></div>
                                    <div>{this.liveLot(val)}</div>
                                    <div className="lot-name">{val.name_lot + ' ' + val.game_type}</div>
                                </div>
                            </li>
                        })}
                    </ul>
                )
            }
            var tariUnique = this.uniq(tari),
            filtruLoterii = []
            this.state.loteriiNormale.map((loterii, i) => {
                if (loterii.name_lot.toLowerCase().indexOf(this.props.filtru.toLowerCase()) !== -1) {
                    filtruLoterii.push(loterii.name_lot)
                } return true
            })

            var filtruTari = []
            tariUnique.map((tari, k) => {
                if (tari.toLowerCase().indexOf(this.props.filtru.toLowerCase()) !== -1) {
                    filtruTari.push(tari)
                } return true
            })

            var tariGrup = {}
            for (var z = 0; z < tariUnique.length; z++) {
                var grup = [];
                for (var q = 0; q < this.state.loteriiNormale.length; q++) {
                    if (tariUnique[z] === this.state.loteriiNormale[q].tara) {
                        grup.push(this.state.loteriiNormale[q])
                    }
                }
                tariGrup = { ...tariGrup, [tariUnique[z]]: grup }
            }
            var liArr = []
            for (var w = 0; w < tariUnique.length; w++) {
                if (tariGrup[tariUnique[w]].length === 1) {
                    for (let a = 0; a < filtruLoterii.length; a++) {
                        if (filtruLoterii[a] === tariGrup[tariUnique[w]][0].name_lot) {
                            liArr.push(<li
                                key={tariGrup[tariUnique[w]][0].name_lot}
                                className={this.isActive(tariGrup[tariUnique[w]][0].name_lot)}
                                onClick={this.changeActive.bind(this, tariGrup[tariUnique[w]][0].name_lot)}>
                                <div>
                                    <div className="img-con"><img src={"img/steaguri/" + this.props.appProps.steaguri + '/' + tariGrup[tariUnique[w]][0].country_flags.toLowerCase().replace(/ /g, "_") + ".png"} alt="" /></div>
                                    <div className="lot-name">{this.liveLot(tariGrup[tariUnique[w]][0])}{tariGrup[tariUnique[w]][0].name_lot + ' ' + tariGrup[tariUnique[w]][0].game_type}</div>
                                </div>
                            </li>
                            )
                        }
                    }
                }
                if (tariGrup[tariUnique[w]].length > 1) {

                    var filtruTaraLoteriei = []
                    var ulLiArr = [];
                    for (var e = 0; e < tariGrup[tariUnique[w]].length; e++) {
                        for (let h = 0; h < filtruLoterii.length; h++) {
                            if (filtruLoterii[h] === tariGrup[tariUnique[w]][e].name_lot) {
                                filtruTaraLoteriei.push(tariUnique[w])
                                ulLiArr.push(<li
                                    key={tariGrup[tariUnique[w]][e].name_lot}
                                    className={this.isActive(tariGrup[tariUnique[w]][e].name_lot)}
                                    onClick={this.changeActive.bind(this, tariGrup[tariUnique[w]][e].name_lot)}>
                                    <div className={this.isActiveFromSelect(tariGrup[tariUnique[w]][e].name_lot)}>
                                        <div className="img-con"><img src={"img/steaguri/" + this.props.appProps.steaguri + '/' + tariGrup[tariUnique[w]][e].country_flags.toLowerCase().replace(/ /g, "_") + ".png"} alt="" /></div>
                                        <div className="lot-name">{this.liveLot(tariGrup[tariUnique[w]][e])}{tariGrup[tariUnique[w]][e].name_lot + ' ' + tariGrup[tariUnique[w]][e].game_type}</div>
                                    </div>
                                </li>)
                            }
                        }
                    }

                    var filtruTaraLoterie = _.union(filtruTari, filtruTaraLoteriei)

                    for (let l = 0; l < filtruTaraLoterie.length; l++) {
                        if (filtruTaraLoterie[l] === tariUnique[w]) {

                            liArr.push(
                                <li
                                    key={tariUnique[w]}
                                    onClick={this.taraDD.bind(this, tariGrup[tariUnique[w]][0], filtruTaraLoterie[l])}
                                    // onChange={this.taraDD.bind(this, tariGrup[tariUnique[w]][0], filtruTaraLoterie[l])}
                                    className={this.taraDDClass(tariUnique[w])}
                                >
                                    <div className={this.isActiveFromSelect(tariGrup[tariUnique[w]][0].name_lot) + ' country-selected'}>
                                        <div className="img-con"><img src={"img/steaguri/" + this.props.appProps.steaguri + '/' + tariGrup[tariUnique[w]][0].country_flags.toLowerCase().replace(/ /g, "_") + ".png"} alt="" /></div>
                                        <div>{this.liveCountries(tariUnique[w])}{tariUnique[w]}</div>
                                        <img className="chevron" src={this.arrow(tariUnique[w])} alt="" />
                                    </div>
                                    <ul>
                                        {ulLiArr}
                                    </ul>
                                </li>
                            )

                        }
                    }

                }

            }
            return liArr;
        } else if (this.props.conSizeChange.appW && this.props.conSizeChange.appW < 1000) {
            if (this.props.loterii) {
                return (
                    this.props.loterii.map((val) => {
                        if (this.props.filtru && this.props.filtru !== '') {
                            if (val.name_lot.toLowerCase().indexOf(this.props.filtru.toLowerCase()) > -1) {
                                return <li
                                    key={val.name_lot}
                                    className={this.isActive(val.name_lot)}
                                    onClick={this.changeActive.bind(this, val.name_lot)}>
                                    <div className='info-container'>
                                        <div className="img-con">
                                            <img className="country-icon" src={"img/steaguri/" + this.props.appProps.steaguri + '/' + val.country_flags.toLowerCase().replace(/ /g, "_") + ".png"} alt="" />
                                            {this.liveLot(val)}
                                        </div>
                                        <div className="lot-name">{val.name_lot + ' ' + val.game_type}</div>
                                    </div>
                                </li>
                            }
                        } else {
                            return <li
                                key={val.name_lot}
                                className={this.isActive(val.name_lot)}
                                onClick={this.changeActive.bind(this, val.name_lot)}>
                                <div className='info-container'>
                                    <div className="img-con">
                                        <img className="country-icon" src={"img/steaguri/" + this.props.appProps.steaguri + '/' + val.country_flags.toLowerCase().replace(/ /g, "_") + ".png"} alt="" />
                                        {this.liveLot(val)}
                                    </div>
                                    <div className="lot-name">{val.name_lot + ' ' + val.game_type}</div>
                                </div>
                            </li>
                        }
                        return true
                    })
                )
            } else {
                if (this.state.loteriiNormale) {
                    return (
                        this.state.loteriiNormale.map((val) => {
                            return <li
                                key={val.name_lot}
                                className={this.isActive(val.name_lot)}
                                onClick={this.changeActive.bind(this, val.name_lot)}>
                                <div className='info-container'>
                                    <div className="img-con"><img src={"img/steaguri/" + this.props.appProps.steaguri + '/' + val.country_flags.toLowerCase().replace(/ /g, "_") + ".png"} alt="" /></div>
                                    <div className="lot-name">{val.name_lot + ' ' + val.game_type}</div>
                                </div>
                            </li>
                        })

                    )
                }
            }
        }
    }
    arrow(val) {
        var runq = val;
        var result = this.state.countries.filter(function (obj) {
            return obj === runq;
        });

        if (result.length > 0) {
            return "img/icon/angle-down.png"
        }
        else {
            return "img/icon/angle-right.png";
        }

    }
    taraDD(val, e, filtruTara) {
        this.setState({ countries: fn.changeArrayValuesLotteries([val.tara, this.state.countries]) });
        var dimensions = ReactDOM.findDOMNode(this).getBoundingClientRect();
        this.props.acConSizeChange({ colSt: dimensions.height })
    }
    taraDDClass(val) {
        var runq = val;
        var result = this.state.countries.filter(function (obj) {
            return obj === runq;
        });
        if (result.length > 0) {
            return 'selected';
        } else if (this.props.filtru.length > 0) {
            return 'selected no-arrow';
        }
        else {
            return '';
        }
    }
    render() {
        if (this.props.loterii !== null) {
            return (
                <ul className="mainList" ref={(f) => this.refColSt = f}>
                    {
                        this.liList()
                    }
                </ul>
            )
        } else {
            return <div></div>
        }
    }
}
function mapStateToProps(state) {
    return {
        appProps: state.appProps,
        loterii: state.loterii,
        activeLot: state.activeLot,
        defaultVal: state.defaultVal,
        conSizeChange: state.conSizeChange,
        sessionParam: state.sessionParam,
        multiLang: state.multiLang
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acActiveLot: acActiveLot,
        acAxiosRequest: acAxiosRequest,
        acRundaSelectata: acRundaSelectata,
        acConSizeChange: acConSizeChange,
        acLiveLot: acLiveLot
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ButStItem);
